import type { FaireProductEntity } from "../../entity_types/product";

export const p_rnvd6szu7q: FaireProductEntity = {
  token: "p_rnvd6szu7q",
  type: "product",
  name: "Crystal XS Pyramid Mix - 50 Pyramids",
  brandToken: "b_eqykpyrhjx",
  brandName: "The Healing Sanctuary",
  imageUrl:
    "https://cdn.faire.com/fastly/126c50afa3891fbe37d08623f69ebf4563b9ac431cddf5bc841f8b6d6bcc44c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e99299fd0d339a0c1c0538204be31f8686afbda859ad0313273f34583044e733.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "You will receive 50 mini (tiny) crystal pyramids. These will not be labeled and range from 1/4 to 1/2 inch. **these are small (tiny)\n\n*Crystals comes from Mother Earth, there will be slight variations for each stone, color, size, shape, etc. All metaphysical information given by The Healing Sanctuary is for spiritual purposes only.\n\n*Each and every crystal shipped from us is blessed with Reiki Love.\n\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:45.374Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
